<img src="../../../../assets/images/StackedLogo.svg" alt="TechInsights" height="50" width="120"/>
<h4 class="title">Sign in or register to view more</h4>
<div class="description">You’ve viewed your item limit for the week. Get unlimited access to critical semiconductor insights by signing in now.</div>
<form #formRef (ngSubmit)="onSubmit()" class="panel-container">
    <input type="hidden" name="app" value="UNIFIEDUI-PROFILE"/>
    <input type="email" name="username" [formControl]="emailCtrl" placeholder="Enter your work email"/>
    <input type="submit" (click)="onReadFullVersion()" value="Unlock Insights" />
</form>
<app-cookie-link></app-cookie-link>